// extracted by mini-css-extract-plugin
module.exports = {"input":"LeadForm_input__MOS7G","label":"LeadForm_label__wx80l"};